import PurchaseOrderVendorTypes from './POVTypes';

export const getVendorPurchaseOrderListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_PROGRESS,
    payload,
  };
};

export const getVendorPurchaseOrderListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_SUCCESS,
    payload,
  };
};

export const getVendorPurchaseOrderListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_ERROR,
    payload,
  };
};

export const getPOInfoInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PO_INFO_PROGRESS,
    payload,
  };
};

export const getPOInfoInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PO_INFO_ERROR,
    payload,
  };
};

export const getPOInfoInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PO_INFO_SUCCESS,
    payload,
  };
};

export const setPoInfoDefault = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_PO_INFO_DEFAULT,
    payload,
  };
};

export const getPackagesInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_PROGRESS,
    payload,
  };
};

export const getPackagesInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_ERROR,
    payload,
  };
};

export const getPackagesInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_SUCCESS,
    payload,
  };
};

export const regularOrdersResetValue = () => {
  return {
    type: PurchaseOrderVendorTypes.REGULAR_ORDER_DATA_RESET,
  };
};

export const saveRegularOrdersInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_PROGRESS,
    payload,
  };
};

export const saveRegularOrdersInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_ERROR,
    payload,
  };
};

export const saveRegularOrdersInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_SUCCESS,
    payload,
  };
};

export const setPackageModal = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_PACKAGE_MODAL_TOGGLE,
    payload,
  };
};

export const savePackageInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_PROGRESS,
    payload,
  };
};

export const savePackageInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_ERROR,
    payload,
  };
};

export const savePackageInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_SUCCESS,
    payload,
  };
};

export const saveShipementInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_PROGRESS,
    payload,
  };
};

export const saveShipementInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_ERROR,
    payload,
  };
};

export const saveShipementInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_SUCCESS,
    payload,
  };
};

export const setTotalPurchaseOrderCount = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_PURCHASE_ORDER_TOTAL_COUNT,
    payload,
  };
};

export const setVendorPurchaseOrderList = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_VENDOR_PURCHASE_ORDER_LIST,
    payload,
  };
};

export const getVendorShipperListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_PROGRESS,
    payload,
  };
};

export const getVendorShipperListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_SUCCESS,
    payload,
  };
};

export const getVendorShipperListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_ERROR,
    payload,
  };
};

export const getVendorConsigneeListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_PROGRESS,
    payload,
  };
};

export const getVendorConsigneeListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_SUCCESS,
    payload,
  };
};

export const getVendorConsigneeListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_ERROR,
    payload,
  };
};
export const getVendorShipmentDetailListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_PROGRESS,
    payload,
  };
};

export const getVendorShipmentDetailListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_SUCCESS,
    payload,
  };
};

export const getVendorShipmentDetailListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_ERROR,
    payload,
  };
};

export const getVendorShipmentItemDetailListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_PROGRESS,
    payload,
  };
};

export const getVendorShipmentItemDetailListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_SUCCESS,
    payload,
  };
};

export const getVendorShipmentItemDetailListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_ERROR,
    payload,
  };
};

export const getBarCode = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_BAR_CODE,
    payload,
  };
};

export const getBarCodeSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_BAR_CODE_SUCCESS,
    payload,
  };
};

export const getBarCodeError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_BAR_CODE_Fail,
    payload,
  };
};

export const getVendorShipmentSummaryListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_PROGRESS,
    payload,
  };
};

export const getVendorShipmentSummaryListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_SUCCESS,
    payload,
  };
};

export const getVendorShipmentSummaryListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_ERROR,
    payload,
  };
};

export const getVendorShipmentLadingListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_PROGRESS,
    payload,
  };
};

export const getVendorShipmentLadingListInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_SUCCESS,
    payload,
  };
};

export const getVendorShipmentLadingListInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_ERROR,
    payload,
  };
};

export const setSelectedShipper = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPPER,
    payload,
  };
};

export const setSelectedConsignee = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SELECTED_CONSIGNEE,
    payload,
  };
};

export const createShipementInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_PROGRESS,
    payload,
  };
};

export const createShipementInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_ERROR,
    payload,
  };
};

export const createShipementInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_SUCCESS,
    payload,
  };
};

export const createShipementInReset = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_RESET,
    payload,
  };
};

export const setPayloadShipData = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_PAYLOAD_SHIP_DATA,
    payload,
  };
};

export const getRoutingGuideInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE,
    payload,
  };
};

export const getRoutingGuideInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE_ERROR,
    payload,
  };
};

export const getRoutingGuideInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE_SUCCESS,
    payload,
  };
};

export const setSelectedShipmentItemDetail = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPMENT_ITEM_DETAIL,
    payload,
  };
};

export const setSelectedShipmentSummary = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPMENT_SUMMARY,
    payload,
  };
};

export const saveVendorAddressInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_PROGRESS,
    payload,
  };
};

export const saveVendorAddressInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_ERROR,
    payload,
  };
};

export const saveVendorAddressInSuccess = () => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_SUCCESS,
  };
};

export const saveVendorAddressInReset = () => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_RESET,
  };
};

export const setSaveShipmentData = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SAVE_SHIPMENT_DATA,
    payload,
  };
};

export const cancelShipementInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_PROGRESS,
    payload,
  };
};

export const cancelShipementInError = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_ERROR,
    payload,
  };
};

export const cancelShipementInSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_SUCCESS,
    payload,
  };
};

export const cancelShipementInReset = () => {
  return {
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_RESET,
  };
};

export const getVendorSearchRequest = (payload) => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH, payload };
};

export const getVendorSearchSuccess = (payload) => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_SUCCESS, payload };
};

export const getVendorSearchFail = (payload) => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_FAIL, payload };
};

export const getVendorSearchClear = () => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_CLEAR };
};

export const getVendorSearchUpdate = (payload) => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_UPDATE, payload };
};

export const updateVendorSearchFilter = (payload) => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_FILTER, payload };
};

export const deleteVendorAddressRequest = (payload) => {
  return { type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS, payload };
};

export const deleteVendorAddressSuccess = () => {
  return {
    type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_SUCCESS,
  };
};

export const deleteVendorAddressFail = (payload) => {
  return { type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_FAIL, payload };
};

export const deleteVendorAddressReset = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_RESET,
    payload,
  };
};

export const addVendorRecord = () => {
  return { type: PurchaseOrderVendorTypes.ADD_VENDOR_ADDRESS_RECORD };
};

export const setSelectAllItemsPOV = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.SET_SELECT_ALL_CHECK_POV,
    payload,
  };
};

export const removeVendorSummaryList = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.REMOVE_VENDOR_SUMMARY_LIST,
    payload,
  };
};

export const getCustomerRouterSettingInprogress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING,
    payload,
  };
};

export const getCustomerRouterSettingSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING_SUCCESS,
    payload,
  };
};

export const getCustomerRouterSettingFail = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING_FAIL,
    payload,
  };
};

export const resetOrderListInProgress = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST,
    payload,
  };
};

export const resetOrderListSuccess = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST_SUCCESS,
    payload,
  };
};

export const resetOrderListFail = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST_FAIL,
    payload,
  };
};

export const packageLoadTypeActionHandler = (payload) => {
  return {
    type: PurchaseOrderVendorTypes.PACKAGE_LOAD_TYPE_DATA,
    payload,
  };
};
